var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SylController } from '@syllepsis/adapter';
import { AllSelection } from 'prosemirror-state';
import { checkParentHaveAttr, checkParentSupportAttr, setAlign } from '../../../utils';
var AlignController = /** @class */ (function (_super) {
    __extends(AlignController, _super);
    function AlignController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.checkActive = true;
        _this.value = 'left';
        _this.toolbar = {
            handler: function (editor) { return _this.command.setStyle(editor); }
        };
        _this.command = {
            setStyle: function (editor) {
                setAlign(editor.view, _this.value);
                editor.focus();
            }
        };
        _this.disable = function (editor) { return !(editor.view.state.selection instanceof AllSelection) && !checkParentSupportAttr(editor.view, 'align'); };
        _this.active = function () { return (_this.checkActive ? checkParentHaveAttr(_this.editor.view, 'align', _this.value) : false); };
        return _this;
    }
    return AlignController;
}(SylController));
export { AlignController };
//# sourceMappingURL=index.js.map